import React, { useState } from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import PlanCards from './Components/PlanCards';
import OfsCartSection from './Components/CartSection';
import Payment from './Components/Payment';
import Summary from './Components/Summary';

function SellPhysicalRechargeVouchers () {
   
  const [showCart,setShowCart]=useState(false)
  const[showCards,setShowCards]=useState(false)
  const[PageName,setPageName]=useState('home')
  const[cartDetails,setCartDetails]=useState([])
  const [cartList,setCartList] = useState([]) 
  const[summaryData,setSummary]=useState([]) 

 


  const getCards = (input, e) => {
    setShowCards(input);
  };
  
  const getShowCart=(input,response,list)=>{
    setShowCart(input)
    setCartDetails(response)
    setCartList(list)
  }


  const handlePagename = (input, e) => {
    setPageName(input);
  };


  const handleSummaryData = (input, e) => {
    setSummary(input);
  };



 
  return (
    <div>

      <DashboardLayout>
      <DashboardNavbar />

        {PageName ==='home' &&  
          <PlanCards handleShowCart={getShowCart} handlePage={handlePagename} />
        }


        {PageName ==='cart' &&  
          <OfsCartSection  details={cartDetails}   cartLists={cartList}   showCart={getShowCart}  showCards={ getCards} handlePage={handlePagename} handleSummary={handleSummaryData} />
        }


        {PageName ==='payment' &&  
          <Payment details={cartDetails}   showCart={getShowCart}  showCards={ getCards} handlePage={handlePagename} handleSummary={handleSummaryData} />
        }


        {PageName ==='summary' &&  
          <Summary summaryData={summaryData}/>
        }


      </DashboardLayout>
    </div>
  )
}

export default SellPhysicalRechargeVouchers